import jsonata from "jsonata";
import moment from "moment";
import { getMasterdata } from "../services";

export class PortalJsonata {
  private registerFunction(expression: jsonata.Expression) {
    expression.registerFunction(
      "filterKey",
      (arr: string[], keyArray: string[], checkEqual: boolean) => {
        if (!Array.isArray(arr) || arr.length === 0) {
          return [];
        }

        const result = arr.filter((item: any) => {
          if (typeof item === "number") {
            item = item.toString();
          }
          const check = keyArray.some((key) => item.includes(key));
          if (checkEqual) {
            return check;
          }
          return !check;
        });
        return result;
      }
    );

    expression.registerFunction(
      "getMasterdataValue",
      async (masterdata: string, filterValue?: string[]) => {
        let temp = await getMasterdata(window.location.host, masterdata)
          .then((res) => {
            if (!filterValue || filterValue.length === 0) return res;
            return res.filter((item) => filterValue.includes(item.value));
          })
          .catch((_) => []);
        const final = temp.map((item: { label: any }) => item.label);

        return final.some((v) => !v) ? [] : final;
      }
    );

    expression.registerFunction(
      "calculateSalary",
      (minSalary: string, maxSalary: string, defaultText?: string) => {
        let actualMinSalary = parseInt(minSalary);
        let actualMaxSalary = parseInt(maxSalary);
        if (typeof minSalary === "string") {
          actualMinSalary = parseInt(minSalary.replaceAll(",", ""));
        }
        if (typeof maxSalary === "string") {
          actualMaxSalary = parseInt(maxSalary.replaceAll(",", ""));
        }

        if (Number.isNaN(actualMinSalary)) {
          actualMinSalary = 0;
        }

        if (Number.isNaN(actualMaxSalary)) {
          actualMaxSalary = 0;
        }

        let salaryText = defaultText;

        if (actualMinSalary || actualMaxSalary) {
          salaryText = "";
          if (actualMinSalary) {
            salaryText = `${Math.ceil(actualMinSalary / 1000000)}`;
          }

          if (actualMaxSalary) {
            salaryText += ` - ${Math.ceil(actualMaxSalary / 1000000)}`;
          }

          if (!actualMinSalary && actualMaxSalary) {
            salaryText = salaryText.slice(3);
          }

          salaryText += " triệu";
        }

        return salaryText;
      }
    );

    expression.registerFunction(
      "calculateSalaryWithShowOption",
      (
        minSalary: string,
        maxSalary: string,
        isShowSalary: boolean,
        defaultText?: string,
        separator: string = ".",
        suffix: string = "đồng"
      ) => {
        if (!isShowSalary) return defaultText ?? "Thoả thuận";

        let actualMinSalary = parseInt(minSalary);
        let actualMaxSalary = parseInt(maxSalary);
        if (typeof minSalary === "string") {
          actualMinSalary = parseInt(minSalary.replaceAll(",", ""));
        }
        if (typeof maxSalary === "string") {
          actualMaxSalary = parseInt(maxSalary.replaceAll(",", ""));
        }

        if (Number.isNaN(actualMinSalary)) {
          actualMinSalary = 0;
        }

        if (Number.isNaN(actualMaxSalary)) {
          actualMaxSalary = 0;
        }

        if (!(actualMinSalary || actualMaxSalary)) {
          return defaultText ?? "Thoả thuận";
        }

        let salaryText = "";

        const currencyFormatter = (amount: number) => {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        };

        if (actualMinSalary) {
          salaryText = `${currencyFormatter(actualMinSalary)}`;
        }

        if (actualMaxSalary && actualMaxSalary != actualMinSalary) {
          salaryText += ` - ${currencyFormatter(actualMaxSalary)}`;
        }

        salaryText += ` ${suffix}`;

        return salaryText;
      }
    );

    expression.registerFunction(
      "formatDate",
      (date: any, defaultValue?: string, format?: string) => {
        if (!date) {
          return defaultValue || "";
        }

        const momentObject = moment(date);

        if (!momentObject.isValid) {
          return defaultValue || "";
        }

        return momentObject.format(format || "DD/MM/YYYY");
      }
    );
  }

  async transform(data: any, transformString: string) {
    try {
      const expressionBody = jsonata(transformString);
      this.registerFunction(expressionBody);
      return await expressionBody.evaluate(data);
    } catch (e) {
      console.log("jsonata error", e);
      return null;
    }
  }
}
